import React from 'react'

import { Route } from 'react-router-dom'

import CoreLayout from 'layouts/CoreLayout'
import { withRouter } from 'utils/withRouter'

import Authentication from './Authentication'

// Every route renders its view inside the authenticated CoreLayout.
const AuthenticatedLayout = Authentication(CoreLayout)

type RouteConfig = {
  path: string
  main: React.ComponentType<any>
  auth?: boolean
  drawer?: boolean
}

// Builds a v6 <Route>; `main` is wrapped with withRouter so views keep receiving match.params/location. auth/drawer default on.
// key={path} is load-bearing: forces CoreLayout to remount on route-pattern change (so mount-only fetchCurrentUser reruns) but not on param-only changes, matching v5.
const routeWithLayout = ({ path, main, auth = true, drawer = true }: RouteConfig) => (
  <Route
    key={path}
    element={<AuthenticatedLayout key={path} auth={auth} drawer={drawer} main={withRouter(main)} />}
    path={path}
  />
)

export default routeWithLayout
